import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { Link } from 'react-router';
import { getConfiguration } from '../../drawer-contents/AssignmentsContentPanel/assignmentsContentPanelService';

class MultipleSelectionButton extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.state = {
      multipleHover: false
    };
  }

  static propTypes = {
    currentSelection: PropTypes.object,
    openChooseMultiple: PropTypes.func,
    multipleIcon: PropTypes.string,
    mode: PropTypes.string
  };

  componentDidMount() {
    if (!this.isEditable()) {
      this.setState({
        multipleHover: true
      });
    }
  }

  multipleSelectorHoverHandler = value => {
    this.setState({
      multipleHover: this.isEditable() ? value : true
    });
  };

  openChooseMultiple = () => {
    const { openChooseMultiple } = this.props;
    if (this.isEditable()) {
      openChooseMultiple();
    }
  };

  isEditable() {
    const { mode } = this.props;
    return getConfiguration(mode).groups;
  }

  getColorStyle = () => {
    const { currentSelection } = this.props;
    const { multipleHover } = this.state;

    let colorStyle = 'grayscale';

    if (this.isEditable() && multipleHover) {
      colorStyle = '';
    }

    if (currentSelection && currentSelection.users && currentSelection.users.length) {
      colorStyle = '';
    }

    if (currentSelection && currentSelection.id && currentSelection.id.length && currentSelection.isGroup === false) {
      colorStyle = '';
    }

    return colorStyle;
  };

  render() {
    const { multipleIcon } = this.props;
    const colorStyle = this.getColorStyle();

    return (
      <div className="students-group-component">
        <Link
          onClick={this.openChooseMultiple}
          onMouseLeave={() => this.multipleSelectorHoverHandler(false)}
          onMouseOver={() => this.multipleSelectorHoverHandler(true)}
        >
          <div className={`students-group-circle choose ${colorStyle}`}>
            <img src={multipleIcon} alt="presentation" className={colorStyle} />
          </div>
          <div className={`students-group-title choose primary ${colorStyle}`}>
            {I18n.t('rightPanel.multiple.assignTitle')}
          </div>
        </Link>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    multipleIcon: state.theme.images.icons.individualColor
  };
}

export default connect(mapStateToProps)(MultipleSelectionButton);
